/* unplugin-vue-components disabled */import script from "./idNumber.vue?vue&type=script&lang=ts&setup=true"
export * from "./idNumber.vue?vue&type=script&lang=ts&setup=true"

export default script